export const formatNumberWithSpaces = (number: number) => {
  const formatter = new Intl.NumberFormat('fr-FR')
  return formatter.format(number)
}
